"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CalendarIntegrationSettingsSchema () {
        return CalendarIntegrationSettingsSchema;
    },
    get CalendarIntegrationSettingsSchemaWithDefault () {
        return CalendarIntegrationSettingsSchemaWithDefault;
    }
});
const _zod = require("zod");
const CalendarIntegrationSettingsSchema = _zod.z.object({
    enabled: _zod.z.boolean()
});
const CalendarIntegrationSettingsSchemaWithDefault = _zod.z.object({
    enabled: _zod.z.boolean().default(false)
});
